import { FormatStyle } from "./enums/SaveMode";
import { ModelMapAbstract } from "./ModelMapAbstract";

export class DriverModel { }


export interface DriverMaster {
    DriverID: number;
    DriverName: string;
    DriverCode: string;
    Mobile: string;
    AlternateMobile: string;
    Email: string;
    DOB: Date;
    Gender: number;
    Aadhar: string;
    PAN: string;
    Experience: number;
    DLNumber: string;
    DLExpiryDate: Date;
    JobType: number;
    CountryID: number;
    StateID: number;
    City: string;
    Address: string;
    PinCode: string;
    Remarks: string;
    IsActive: boolean;
    CreatedBy: number;
    CreatedDate: Date;
    UpdateBy: number;
    UpdateDate: Date;
    LocationId: number;
}


export class ViewDriver {
    DriverID: number;
    DriverName: string;
    DriverCode: string;
    Mobile: string;
    AlternateMobile: string;
    Email: string;
    DOB: Date;
    Gender: number;
    Aadhar: string;
    PAN: string;
    Experience: number;
    DLNumber: string;
    DLExpiryDate: Date;
    JobType: number;
    CountryID: number;
    StateID: number;
    City: string;
    Address: string;
    PinCode: string;
    Remarks: string;
    IsActive: boolean;
    CreatedBy: number;
    CreatedDate: Date;
    UpdateBy: number;
    UpdateDate: Date;
}


export class DriverModelMap implements ModelMapAbstract {
    fieldSettings: (string | number)[][] = [
        ['Driver Code', 'DriverCode', FormatStyle.None],
        ['Driver Name', 'DriverName', FormatStyle.None],
        ['Mobile', 'Mobile', FormatStyle.None],
        ['DOB', 'DOB', FormatStyle.DDMMYYYY],
        ['DL Number', 'DLNumber', FormatStyle.None],
        ['DL Expiry Date', 'DLExpiryDate', FormatStyle.DDMMYYYY],
        ['Status', 'IsActive', FormatStyle.None],
        ['Mobile', 'Mobile', FormatStyle.None],
        ['Alternate Mobile', 'AlternateMobile', FormatStyle.None],
        ['Email', 'Email', FormatStyle.None],
        ['Gender', 'GenderName', FormatStyle.None],
        ['Aadhar', 'Aadhar', FormatStyle.None],
        ['PAN', 'PAN', FormatStyle.None],
        ['Job Type', 'JobTypeName', FormatStyle.None],
        ['Experience', 'Experience', FormatStyle.None],
        ['Country', 'Country', FormatStyle.None],
        ['State', 'State', FormatStyle.None],
        ['City', 'City', FormatStyle.None],
        ['Address', 'Address', FormatStyle.None],
        ['PinCode', 'PinCode', FormatStyle.None],
        ['Remarks', 'Remarks', FormatStyle.None],
        
       
    ];
}
